import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/fi';
import 'dayjs/locale/sv';
import 'dayjs/locale/nb';

dayjs.extend(require('dayjs/plugin/utc'));
dayjs.extend(require('dayjs/plugin/timezone'));
dayjs.extend(require('dayjs/plugin/localizedFormat'));
dayjs.extend(require('dayjs/plugin/isBetween'));
dayjs.extend(require('dayjs/plugin/duration'));
